<template>
    <footer
        id="footer"
        class="footer"
    >
        <el-popover
            v-if="isAppVersion"
            placement="top"
            trigger="click"
        >
            <div>
                <p>
                    FE:<br>
                    {{ info.__BRANCH__ }}<br>
                    {{ info.__VERSION__ }}<br>
                    {{ info.__COMMITHASH__ }}<br>
                    {{ info.__COMMIT_DATETIME__ }}<br>
                </p>
                <p>
                    API:<br>
                    {{ info.apiVersion }}
                </p>
            </div>
            <icon
                id="version-tooltip"
                slot="reference"
                name="#info"
            />
        </el-popover>
        <section class="footer__legal">
            <span class="footer__copyright">
                &copy; {{ copyright.year }} &nbsp;
                <a
                    :href="copyright.links.corporate.url"
                    class="footer__legal__link"
                    target="_blank"
                    v-text="copyright.links.corporate.title"
                />
            </span>
        </section>
    </footer>
</template>


<script>
import { mapGetters } from 'vuex';
import Icon from 'shared-lib/components/ui/Icon';

export default {
    components: {
        Icon,
    },

    data () {
        return {
            copyright: {
                year:       new Date().getFullYear(),
                links: {
                    corporate: {
                        title: 'Upyield',
                        url:   'https://upyield.io/',
                    },
                },
            },
        };
    },

    computed: {
        ...mapGetters([
            'isCurrentUserAdmin',
            'apiVersion',
        ]),
        info () {
            /* eslint-disable no-undef */
            return {
                __BRANCH__: __BRANCH__,
                __VERSION__: __VERSION__,
                __COMMITHASH__: __COMMITHASH__,
                __COMMIT_DATETIME__: __COMMIT_DATETIME__,
                apiVersion: this.apiVersion,
            };
            /* eslint-enable no-undef */
        },
        isAppVersion () {
            return ['development'].includes(process.env.NODE_ENV) || (['production'].includes(process.env.NODE_ENV) && this.isCurrentUserAdmin);
        },
    },
};
</script>


<style lang="scss">
    .tooltip-inner {
        white-space: pre-line;
    }

    .footer {
        color: $font-color--default;
        background-color: $color-brand-background;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        #version-tooltip {
            margin-left: 10px;
            color: $color-gray--lighten-1;
            outline: none;
            cursor: pointer;
        }

        &__legal {
            flex: 1;
            justify-content: flex-end;
        }

        section {
            display: flex;
            padding: $gutter--s $gutter--xl $gutter--l $gutter--xl;
        }

        &__button {
            border: $border-style;
            color: $color-gray--darken-2;

            &:hover {
                background-color: $color-brand--lighten-2;
                color: $color--positive;
            }
        }

        &__legal,
        &__support {
            padding: $gutter $gutter--l;
            text-align: right;
            line-height: normal;
        }

        &__support {
            background-color: $color-gray--lighten-1;
            border-top: $border-style--base;
        }

        &__support__note {
            padding-bottom: $gutter;
            @include media-breakpoint-up(md) {
                display: inline-block;
                margin-right: $gutter--s;
            }
        }

        &__legal__link:hover {
            text-decoration: underline;
        }

        &__legal > &__legal__link {
            color: $font-color--active;
        }
    }
</style>
